import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledProductCancelError = styled.p`
  ${({ theme: { colors } }) => `
    color: ${colors.error};
  `}
`;
